export const streetsCollectionGuard = 'GET /v2/streets';
export const streetsResourceGuard = 'GET /v2/streets/d+';
export const createStreetGuard = 'POST /v2/streets';
export const addStreetAltNameGuard = 'POST /v2/streets/alt/d+/d+';
export const replaceStreetGuard = 'POST /v2/streets/replace/d+/d+';
